// @flow weak

export const appConfig = {
  DEV_MODE: true, // flag to fetch mock or real fetch

  api: {
    fakeEndPoint: 'api/somewhere'
  }
};



// WEBPACK FOOTER //
// ./src/app/config/index.js